import { listByProducts } from '@/apis/brand'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { confirmLogin } from '@/util/useConfirm'
import { ElMessageBox } from 'element-plus'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

// authStatus是用户有没有授权 0和1
// brandStatus是品牌的状态 0草稿 1未发布 2已发布
// hasReleased是这个品牌之前有没有发布过 0和1
// isAuthorizing

export default () => {
  const router = useRouter()
  const store = useStore()
  const productCode = useRoute().params?.id?.toString() ?? ''
  const needAuth = ref(0)
  let brand = ''
  let brandInfo:any = {}
  if (store.getters.isLogin) {
    listByProducts({ productCodeList: [productCode] }).then((res: any) => {
      if (res.success) {
        const data = res.data[0]
        if (data?.brandInfo?.brandId) {
          let value = data.brandInfo.authStatus === 0 && data.brandInfo.hasReleased ? 1 : 0
          if (value) {
            if (data.brandInfo.isAuthorizing) {
              value = 2
            } else if (data.brandInfo.brandStatus !== 2) {
              value = 3
            }
          }
          needAuth.value = value
          brand = data?.brandInfo?.brandId
          brandInfo = data?.brandInfo
        }
      }
    })
  }
  const toAuth = async () => {
    const token = store.getters.token
    const curShop = store.getters.curShop
    if (!token && !curShop) {
      store.commit('status/onLogin', () => {
        store.commit('status/onLogin', null)
      })
      return
    }
    if (!curShop) {
      store.commit('status/toCreateShop', true)
      return
    }
    confirmLogin(async () => {
      // 独家授权校验会员等级
      if (!checkMember(brandInfo?.customerAuthTypeList?.every((v:number) => v === 1), store, router)) return
      router.push(useRtfix('BrandAuth', { query: { brand } }))
    })
  }
  return [needAuth, toAuth] as const
}

export const brandStatus = () => {}
// todo
export const checkMember = (isSpecialBrand:boolean, store:any, router:any) => {
  const templateLevel = store.getters.user?.membership?.templateLevel
  // eslint-disable-next-line no-constant-condition
  // 独家授权要商务舱以上才可以授权 普通需要会员才能申请
  if ((isSpecialBrand && templateLevel < 3) || (!isSpecialBrand && templateLevel < 1)) {
    ElMessageBox.confirm(isSpecialBrand ? t('申请前，请先升级至商务舱会员及以上。') : t('申请前，请先升级至标准会员及以上。'), t('很抱歉，您无法申请该品牌'), {
      confirmButtonText: t('去升舱'),
      cancelButtonText: t('关闭'),
      customClass: 'member-confirm-class'
    }).then(() => {
      router.push(useRtfix('VipLevel'))
    })
    return false
  }
  return true
}
